import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { createSelectors } from "./createSelectorsFunction";

type DownloadState = {
  isDownloading: boolean;
  isGenerateTestsDownloadInProgress: boolean;
  shouldCloseDownloadModal: boolean;
  error: string | null;
  downloadCompleted: boolean;
  actions: {
    setIsDownloading: (isDownloading: boolean) => void;
    setIsGenerateTestsDownloadInProgress: (isInProgress: boolean) => void;
    setShouldCloseDownloadModal: (shouldClose: boolean) => void;
    setError: (error: string | null) => void;
    clearError: () => void;
    setDownloadCompleted: (completed: boolean) => void;
    resetDownloadState: () => void;
  };
};

const initialState: Omit<DownloadState, 'actions'> = {
  isDownloading: false,
  isGenerateTestsDownloadInProgress: false,
  shouldCloseDownloadModal: false,
  error: null,
  downloadCompleted: false,
};

const downloadStore = immer<DownloadState>((set: any) => ({
  ...initialState,
  actions: {
    setIsDownloading: (isDownloading: boolean) => {
      set({ isDownloading }, false, 'Set Is Downloading: ' + isDownloading);
    },
    setIsGenerateTestsDownloadInProgress: (isInProgress: boolean) => {
      set(
        { isGenerateTestsDownloadInProgress: isInProgress },
        false,
        'Set Is Generate Tests Download In Progress: ' + isInProgress
      );
    },
    setShouldCloseDownloadModal: (shouldClose: boolean) => {
      set(
        { shouldCloseDownloadModal: shouldClose },
        false,
        'Set Should Close Download Modal: ' + shouldClose
      );
    },
    setError: (error: string | null) => {
      set({ error }, false, 'Set Download Error: ' + error);
    },
    clearError: () => {
      set({ error: null }, false, 'Clear Download Error');
    },
    setDownloadCompleted: (completed: boolean) => {
      set({ downloadCompleted: completed }, false, 'Set Download Completed: ' + completed);
    },
    resetDownloadState: () => {
      set({
        isDownloading: false,
        isGenerateTestsDownloadInProgress: false,
        shouldCloseDownloadModal: false,
        error: null,
        downloadCompleted: false,
      }, false, 'Reset Download State');
    },
  },
}));

const useDownloadStoreBase = create(
  subscribeWithSelector(
    devtools(downloadStore, { name: "DownloadStore" })
  )
);
const useDownloadStore = createSelectors(useDownloadStoreBase);

export default useDownloadStore;
export const useDownloadStoreActions = () =>
  useDownloadStore((state: any) => state.actions); 